import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async () => {
  return await dponetAPI.get('/kanban_boards')
}

const create = async (data) => {
  return await dponetAPI.post('/kanban_boards', { kanbanBoard: data })
}

const update = async ({ kanbanBoardId, ...data }) => {
  return await dponetAPI.put(`/kanban_boards/${kanbanBoardId}`, {
    kanbanBoard: data,
  })
}

const destroy = async ({ kanbanBoardId }) => {
  return await dponetAPI.delete(`/kanban_boards/${kanbanBoardId}`)
}

export default {
  create,
  destroy,
  get,
  update,
}
